import Chip from "@material-ui/core/Chip";
import dateFormat from "date-fns/format";
import * as jsonexport from "jsonexport/dist";
import { downloadCSV, useNotify } from "ra-core";
import React from "react";
import {
  Datagrid,
  EditButton,
  Filter,
  List,
  SearchInput,
  TextField,
  useTranslate,
} from "react-admin";
import useUserContext from "../../../shared/useUserContext";
import OrgListActions from "./OrgListActions";

const ParticipantTypeField: any = ({ record }) => {
  const translate = useTranslate();
  return (
    <Chip
      label={translate(`portal.label.participant.${record.partType}`)}
    ></Chip>
  );
};

const ParticipantCodeField: any = ({ record }) => {
  return record.code && <Chip label={record.code}></Chip>;
};

const OrgFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
);

export const OrgList = (props) => {
  const userContext = useUserContext();
  const notify = useNotify();

  const exporter = (records) => {
    jsonexport(records, (err, csv) => {
      if (err) {
        console.log("Contact export error: ", err);
        notify("acs.message.contactExportError", "error");
      } else {
        const timestamp = dateFormat(Date.now(), "yyyy-MM-dd_HH-mm-ss");
        const filename = `OCP_Organisations_${timestamp}`;
        downloadCSV(csv, filename);
      }
    });
  };

  return (
    <List
      {...props}
      actions={<OrgListActions />}
      filters={<OrgFilter />}
      syncWithLocation={false}
      bulkActionButtons={false}
      sort={{ field: "updatedAt", order: "DESC" }}
      exporter={exporter}
    >
      <Datagrid rowClick="show">
        <TextField source="name" label="portal.label.orgName" />
        <ParticipantCodeField source="code" label="portal.label.partCode" />
        <ParticipantTypeField source="partType" label="portal.label.partType" />
        {userContext.isInternalAdmin && <EditButton />}
      </Datagrid>
    </List>
  );
};
